import React, { useCallback, useEffect, useState } from 'react';
import type { FC } from 'react';
import type { BuyAgainAddToCartEventPayload } from '../../../../LoginSocialBar.types';
import type { BuyAgainProps } from './BuyAgain.types';
import styles from './BuyAgain.module.scss';
import { DATA_HOOK } from './constants';
import ProductCard from './ProductCard';

const BuyAgain: FC<BuyAgainProps> = ({
  orderItems,
  headerText,
  addToCartText,
  onAddToCart,
  confirmedItem,
}) => {
  const [addingItems, setAddingItems] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!confirmedItem) {
      return;
    }
    const { catalogItemId } = confirmedItem;
    setAddingItems(prev => {
      if (!prev.has(catalogItemId)) {
        return prev;
      }
      const next = new Set(prev);
      next.delete(catalogItemId);
      return next;
    });
  }, [confirmedItem]);

  const handleAddToCart = useCallback(
    (event: BuyAgainAddToCartEventPayload) => {
      const { catalogItemId } = event;
      setAddingItems(prev => {
        if (prev.has(catalogItemId)) {
          return prev;
        }
        const next = new Set(prev);
        next.add(catalogItemId);
        return next;
      });
      onAddToCart(event);
    },
    [onAddToCart],
  );

  if (orderItems.length === 0) {
    return null;
  }

  return (
    <div className={styles.root} data-testid={DATA_HOOK.root}>
      <div className={styles.root__content}>
        <h2 className={styles.root__header} data-testid={DATA_HOOK.header}>
          {headerText}
        </h2>
        <div className={styles.root__list} data-testid={DATA_HOOK.list}>
          {orderItems.map(item => (
            <ProductCard
              key={item.catalogItemId}
              item={item}
              isAdding={addingItems.has(item.catalogItemId)}
              addToCartText={addToCartText}
              onAddToCart={handleAddToCart}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuyAgain;
